// extracted by mini-css-extract-plugin
export default {"fullscreen":"TemplateListPaneFooter-module__fullscreen--HM0wl","link":"TemplateListPaneFooter-module__link--RiA0A"};